
  import { SmartBannerConfig } from './index'
  export const config: SmartBannerConfig = {
    festivalName: 'Rio Loco',
    appTitle: 'Rio Loco',
    appStoreId: '0',
    appleStoreUrl: 'https://apps.apple.com/fr/app/rio-loco/id6449036731',
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=to.chapi.rioloco',
    appIconUrl: 'https://static.rioloco.chapi.to/app-icon.jpeg',
  }
